<template>
  <div class="product-section tea">
    <Container>
      <div class="product-grid">
        <div class="product-info" data-reveal>
          <p class="eyebrow">For a Calmer Ritual</p>
          <h2>Turkey Berry Tea</h2>
          <p class="lead">
            Turkey berry powder as tea can be mixed with other herbs. It is a
            good source of iron, gingerol, fibre and antioxidants which helps
            in preventing high blood sugar and maintains blood sugar balance.
          </p>
          <ul class="benefit-list">
            <li v-for="item in benefits" :key="item">
              <span class="check">&#10003;</span>{{ item }}
            </li>
          </ul>
          <div class="buttons">
            <Button variant="dark">Purchase product</Button>
            <Button variant="outline-dark">Learn more</Button>
          </div>
        </div>
        <div class="product-image" data-reveal>
          <img src="@/assets/tea.jpg" alt="Turkey Berry Tea" />
        </div>
      </div>
    </Container>
  </div>
</template>

<script setup>
import Container from "@/components/Container/Container.vue"
import Button from "@/components/Button/Button.vue"

const benefits = [
  "Rich source of iron & gingerol",
  "High in fibre and antioxidants",
  "Supports balanced blood sugar",
  "Blends well with other herbs",
]
</script>

<style scoped>
.product-section {
  padding: 4rem 0;
}

.tea {
  background: var(--surface-alt);
}

.product-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 4rem;
}

.product-image img {
  width: 100%;
  height: 380px;
  object-fit: cover;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
}

.product-info .eyebrow {
  color: var(--accent-dark);
}

.product-info h2 {
  font-size: clamp(1.7rem, 2.8vw, 2.1rem);
  font-weight: 700;
  color: var(--ink);
}

.product-info .lead {
  margin-top: 0.9rem;
  line-height: 1.75;
  color: var(--body-text);
}

.benefit-list {
  list-style: none;
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.benefit-list li {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  font-weight: 600;
  color: var(--ink);
  font-size: 0.94rem;
}

.check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--accent);
  color: var(--primary-900);
  font-size: 0.7rem;
  flex-shrink: 0;
}

.buttons {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  flex-wrap: wrap;
}

@media (max-width: 1023px) {
  .product-grid {
    gap: 2.5rem;
  }
}

@media (max-width: 768px) {
  .product-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .product-image {
    order: -1;
  }

  .product-image img {
    height: 300px;
  }
}
</style>
